'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accountSettingsComponent = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountSettingsComponent = exports.accountSettingsComponent = {
    template: require('./settings.html'),
    bindings: {
        user: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "authService", "$rootScope", "userService", "Enums", "$scope", "$window", "gettextCatalog", "Analytics", "ngDialog", function controller(common, authService, $rootScope, userService, Enums, $scope, $window, gettextCatalog, Analytics, ngDialog) {
        'ngInject';

        var vm = this;
        vm.name = '';
        vm.apbNumber = '';
        vm.tenants = null;
        vm.selectTenant = selectTenant;
        vm.signOut = signOut;
        vm.$onInit = init;
        vm.modifyName = modifyName;
        vm.modifyPassword = modifyPassword;
        vm.modifyEmail = modifyEmail;
        vm.modifyBuyerEmail = modifyBuyerEmail;
        vm.showModifyBuyerEmail = showModifyBuyerEmail;
        vm.getEmailLanguages = getEmailLanguages;
        vm.amr = '';
        vm.showModifyEmail = false;
        vm.newMail = '';
        vm.selectedLanguage = vm.getEmailLanguages()[0];
        vm.selectedLanguageChanged = selectedLanguageChanged;
        vm.showModifyCommunicationLanguage = showModifyCommunicationLanguage;
        vm.modifyCommunicationLanguage = false;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.changeBuyerBase = changeBuyerBase;
        vm.isShopAdmin = null;

        //update email/communicationlanguage on enter
        angular.element($window).on('keydown', function (event) {
            if (event.which === 13) {
                if (vm.modifyCommunicationLanguage) {
                    vm.selectedLanguageChanged();
                }
                if (vm.showModifyEmail) {
                    vm.modifyBuyerEmail();
                }
            }
        });

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('My account'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account', gettextCatalog.getString('My account'));
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.name = authService.user.display_name;
            vm.apbNumber = activeTenant.apbNumber;
            vm.tenants = tenants;
            vm.pharmacyName = activeTenant.name;
            vm.canViewPackages = activeTenant.canViewPackages;
            vm.email = authService.user.email;
            vm.amr = authService.user.amr;
            vm.showModifyEmail = false;
            vm.communicationLanguage = _lodash2.default.find(Enums.emailLanguages, { 'id': vm.user.communicationLanguageId });
            vm.isShopAdmin = authService.hasClaim('ShopAdmin');
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        function selectTenant(tenant) {
            var _this = this;

            authService.signIn('/', { tenant: tenant }).catch(function () {
                _this.$log.warn('Signin with tenant failed');
            });
            $rootScope.$broadcast('tenant-changed', { secondaryAppUserKey: tenant });
        }

        function signOut() {
            authService.signOut();
        }

        function modifyPassword() {
            return common.config.ssoBaseUrl + '/account?tab=password';
        }

        function modifyName() {
            return common.config.ssoBaseUrl + '/account?tab=general';
        }

        function modifyEmail() {
            return common.config.ssoBaseUrl + '/account?tab=primaryEmail';
        }
        function modifyBuyerEmail() {
            return userService.setBuyerMail(vm.newMail).then(function () {
                userService.getMyAccount().then(function (u) {
                    vm.user.mail = u.mail;
                    showModifyBuyerEmail();
                });
            });
        }
        function showModifyBuyerEmail() {
            vm.showModifyEmail = !vm.showModifyEmail;
        }

        function getEmailLanguages() {
            return Enums.emailLanguages;
        }

        function selectedLanguageChanged() {
            userService.setBuyerMailLanguage(vm.selectedLanguage).then(function (res) {
                vm.communicationLanguage = _lodash2.default.find(Enums.emailLanguages, { 'id': res.id });
                vm.modifyCommunicationLanguage = false;
            });
        }

        function showModifyCommunicationLanguage() {
            vm.modifyCommunicationLanguage ? vm.modifyCommunicationLanguage = false : vm.modifyCommunicationLanguage = true;
        }

        function changeBuyerBase() {
            ngDialog.openConfirm({
                template: '<buyer-base-select on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                className: 'ngdialog ngdialog-theme-webshop',
                plain: true,
                showClose: true,
                closeByNavigation: true
            }).then(function (result) {
                vm.selectTenant(result.id);
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/settings.js
// module id = 892
// module chunks = 0